import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "@mui/material";
import logo from "../../images/logos/logo2.png";
import logo1 from "../../images/logos/logo1.png";

const Header = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      width={"100%"}
      marginBottom={{ xs: 2, sm: 1 }}
      marginTop={{ xs: 2, sm: 1 }}
      id="back-to-top-anchor"
    >
      <Box
        sx={{ display: { xs: "none", md: "flex" } }}
        marginLeft={{ xs: "0%", sm: "0%" }}
        width={230}
      >
        <Box component="a" underline="none" href="/" title="OnDesign">
          <img src={logo} alt="logo" width={"80%"} />
        </Box>
      </Box>
      <Box
        display="flex"
        alignItems={"center"}
        width={{ xs: "100%", sm: "50%" }}
        justifyContent={"space-between"}
        marginRight={{ xs: "0%", sm: "0%" }}
      >
        <Box
          sx={{ display: { xs: "none", md: "flex" } }}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
          fontWeight={600}
        >
          <Box>
            <Link
              underline="none"
              component="a"
              href="/"
              color={"#fff"}
              fontWeight={500}
              sx={{
                "&:hover": {
                  color: "#33E68C",
                },
              }}
            >
              Home
            </Link>
          </Box>
          <Box>
            <Link
              underline="none"
              component="a"
              href="/aboutus"
              fontWeight={500}
              color={"#fff"}
              sx={{
                "&:hover": {
                  color: "#33E68C",
                },
              }}
            >
              About Us
            </Link>
          </Box>
          <Box>
            <Link
              underline="none"
              component="a"
              href="/our-services"
              fontWeight={500}
              color={"#fff"}
              sx={{
                "&:hover": {
                  color: "#33E68C",
                },
              }}
            >
              Our Services
            </Link>
          </Box>
          <Box>
            <Link
              underline="none"
              component="a"
              href="/our-portfolio"
              fontWeight={500}
              color={"#fff"}
              sx={{
                "&:hover": {
                  color: "#33E68C",
                },
              }}
            >
              Our Portfolio
            </Link>
          </Box>
          <Box>
            <Link
              underline="none"
              component="a"
              href="/contact-us"
              color="#fff"
              fontWeight={500}
              sx={{
                "&:hover": {
                  color: "#33E68C",
                },
              }}
            >
              Contact Us
            </Link>
          </Box>
        </Box>
        <Box sx={{ display: { xs: "flex", md: "none" } }} width={"100%"}>
          <AppBar
            position="fixed"
            zIndex={theme.zIndex.drawer + 1}
            sx={{
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Toolbar>
              <Box
                component="a"
                underline="none"
                href="/"
                title="OnDesign"
                width={155}
                marginRight={19}
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  component="img"
                  height={"8vh"}
                  sx={{
                    display: "block",
                    position: "relative",
                    overflow: "hidden",
                    width: "100%",
                  }}
                  src={logo1}
                  alt={"logo"}
                />
              </Box>
              <IconButton
                aria-label="more"
                id="composition-button"
                aria-controls={open ? "composition-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MenuIcon fontSize="large" sx={{ color: "#000" }} />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Menu
            id="fade-menu"
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleClose} component="a" href="/">
              Home
            </MenuItem>
            <MenuItem onClick={handleClose} component="a" href="/aboutus">
              About Us
            </MenuItem>
            <MenuItem onClick={handleClose} component="a" href="/our-services">
              Our Services
            </MenuItem>
            {/* <MenuItem onClick={handleClose} component="a" href="/our-portfolio">
              Our Portfolio
            </MenuItem> */}
            <MenuItem onClick={handleClose} component="a" href="/contact-us">
              Contact Us
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
